angular
    .module('festzelt-os.modules.wallets')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.wallets', {
            abstract: true,
            url: '/wallets/',
            template: '<ui-view/>',
            data: {
                pageTitle: 'Wallet Tickets',
                showBackBtn: true
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/modules/wallets/routes.js